import React from 'react';
import Class12Results2026 from '../views/Class12Results2026/Class12Results2026';

const Class12Results2026Page = () => {
  return <Class12Results2026 />;
};

export default Class12Results2026Page;
